import { PreferenceSection, PreferenceSummary } from 'components/Settings';
import { useTranslation } from 'react-i18next';
import { isFeedbackSettingsDefault } from 'utils/helper';
import { usePreferenceSettings } from '../../Preferences';
import { getFeedbackStructureLabel, getFeedbackSummaryItems, getPreferenceInstructions } from '../preferenceSummary';

const FormativeFeedback = ({ sectionId }) => {
    const { defaults, update, setFeedbackDialog, adminOverrideStates } = usePreferenceSettings();
    const { t } = useTranslation('assignment');
    const settings = defaults.studentFeedbackSettings;
    const additionalInstructions = getPreferenceInstructions(defaults.studentFeedbackCustomContext);
    return (
        <PreferenceSection
            id={sectionId}
            title={t('settings.formative-feedback.title', 'Formative Feedback')}
            description={t(
                'settings.formative-feedback.description',
                'Students can generate feedback for assignment drafts before they submit.'
            )}
            toggleLabel={t('settings.formative-feedback.toggle-label', 'Allow Student Draft Submissions')}
            toggleDescription={t(
                'settings.formative-feedback.toggle-description',
                'Students can generate up to 3 rounds of AI feedback for assignment drafts before they submit.'
            )}
            enabled={defaults.aiStudentFeedbackEnabled}
            adminOverrideState={adminOverrideStates[sectionId]}
            disabled={false}
            onToggle={(value) => update('aiStudentFeedbackEnabled', value)}
        >
            <PreferenceSummary
                actionLabel={t('common:controls.change-settings', 'Change Settings')}
                defaultLabel={t('common:ui.default', 'Default')}
                isDefault={isFeedbackSettingsDefault(settings) && !additionalInstructions}
                items={getFeedbackSummaryItems(settings, additionalInstructions, t)}
                onAction={() => setFeedbackDialog('formative')}
                structure={settings.structure}
                summaryTitle={getFeedbackStructureLabel(settings.structure, t)}
                title={t('formative-feedback.settings-title', 'Formative Feedback Settings')}
            />
        </PreferenceSection>
    );
};

export default FormativeFeedback;
